
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[storeSlug]",
      function () {
        return require("private-next-pages/store/[storeSlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[storeSlug]"])
      });
    }
  